import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorHandlerService } from '@manager-app/service/error-handler.service';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { CountryModel, HxCountryService, HxSupplierService, HxUiLabelPipe, SupplierFullModel } from 'hx-services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgFor, NgIf } from '@angular/common';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { SuppliersContractComponent } from '../suppliers-contract/suppliers-contract.component';
import { RepresentativesNewComponent } from '../representatives-new/representatives-new.component';
import { SuppliersBankComponent } from '../suppliers-bank/suppliers-bank.component';
import { SuppliersAddressComponent } from '../suppliers-address/suppliers-address.component';

@Component({
    selector: 'app-suppliers-new',
    templateUrl: './suppliers-new.component.html',
    styleUrls: ['./suppliers-new.component.css'],
    imports: [NgIf, FormsModule, ReactiveFormsModule, NgSelectComponent, NgFor, NgOptionComponent, SuppliersContractComponent, RepresentativesNewComponent, SuppliersBankComponent, SuppliersAddressComponent, TranslocoPipe, HxUiLabelPipe]
})
export class SuppliersNewComponent implements OnInit {
  @ViewChild('templateRef') public templateRef: TemplateRef<any>;
  @Output() update = new EventEmitter<any>();
  private _id;
  @Input()
  set id(id) {
    this._id = id || null;
    if (id) {
      this.getItem();
    }
  }
  get id() {
    return this._id;
  }
  supplierBank: UntypedFormGroup;
  isLoading = {
    form: false
  };
  isEdit = false;
  countries: CountryModel[] = [];

  constructor(
    private modal: NgbModal,
    private fb: UntypedFormBuilder,
    private supplierService: HxSupplierService,
    private toastr: HcToastrService,
    private errorHandlerService: ErrorHandlerService,
    private countryService: HxCountryService,
    private tr: TranslocoService
  ) { }

  ngOnInit() {
    this.loadCountries();
    this.createForm();
  }

   showModal() {
    this.isEdit = false;
    this.addItem();
  }

   closeModal(modal) {
    this.update.emit(false);
    this.supplierBank.reset();
    if (modal) {
      modal.dismiss();
    }
  }

  onSubmitForm(modal) {
    const obj = this.supplierBank.getRawValue();
    this.supplierService.saveSupplier(obj).subscribe(
      () => {
        if (this.id) {
          this.toastr.success(this.tr.translate('suppliers-new.ts.upSuccess'));
        } else {
          this.toastr.success(this.tr.translate('suppliers-new.ts.addSuccess'));
        }
        this.update.emit(true);
        modal.dismiss();
      },
      err => this.errorHandlerService.check(err.error)
    );
  }

  private getItem() {
    this.isLoading.form = true;
    setTimeout(() => {
      this.addItem();
    }, 0);
    this.supplierService.getSupplierById(this.id).subscribe(
      result => {
        if (result) {
          this.updateForm(result);
        }
        this.isLoading.form = false;
      },
      () => {
        this.toastr.error(this.tr.translate('suppliers-new.ts.error'));
        this.isLoading.form = false;
      }
    );
  }

  private updateForm(item: SupplierFullModel) {
    this.isEdit = true;
    this.supplierBank.patchValue({
      id: this.id,
      countryId: item.country?.id,
      name: item.name,
      description: item.description,
      uin: item.uin,
    });
  }

  private createForm(): void {
    this.supplierBank = this.fb.group({
      id: [null],
      name: [''],
      description: [''],
      uin: [''],
      countryId: [null],
    });
  }

  private addItem() {
    const userModal = this.modal.open(this.templateRef, {size: 'xl'});

    userModal.result.then(
      result => {
        this.closeModal(result);
      }
    ).catch(
      err => {
        this.closeModal(err);
      }
    );
  }

  private async loadCountries() {
    this.countries = await this.countryService.getCountries();
  }
}
